import React from 'react'
import PrintSticker from './PrintSticker'

export default function PrintStickerLayer({ stickers }) {
  if (!Array.isArray(stickers)) return null

  return (
    <>
      {stickers.map((sticker) => (
        <PrintSticker key={sticker.id} sticker={sticker} />
      ))}
    </>
  )
}
